import styled from 'styled-components';
import { ReactComponent as Close } from 'Images/clear.svg';

export const Wrapper = styled.div`
  min-height: 246px;
  background-color: ${({ theme }) => theme.backgrounds.tagsModalContainer};
  padding: 18px 23px 15px 21px;
  margin-bottom: 20px;
  
`;
Wrapper.displayName = 'Wrapper';

export const Label = styled.div`
  font-size: 12.5px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.modalLabel};
  margin-bottom: 12px;
`;
Label.displayName = 'Label';

export const Tags = styled.div`
`;
Tags.displayName = 'Tags';

export const CloseIcon = styled(Close)`
  margin-left: 6px;
  cursor: pointer;
  & > g > g {
    fill: ${({ theme }) => theme.icons.removeTag.color};
  }

`;
CloseIcon.displayName = 'CloseIcon';
